import { createFileRoute } from "@tanstack/react-router";
import { MealDayPage } from "./-MealDayPage";

export const Route = createFileRoute("/_app/_meal-page/meals/$date")({
  component: () => <MealDayPage date={Route.useParams().date} />,
});
